import { ICellRendererParams } from 'ag-grid-community';
import { FC } from 'react';

const KeywordsCellRenderer: FC<ICellRendererParams> = (params) => {
	if (params?.value?.length === 0 || !params?.value) {
		return (
			<div className="flex-1 px-[8px]">Any</div>
		);
	}

	return (
		<div className="flex h-full px-[8px] justify-between items-center gap-2">
			<div className="overflow-hidden">
				<div
					className="overflow-hidden overflow-ellipsis"
					style={{ width: 'calc(100% + 1px)' }}
				>
					{params.value && params.value.length > 0 ? params.value.join(', ') : ''}
				</div>
			</div>

			<div className="flex items-center gap-2">
				{params.value && params.value?.length > 1 && (
					<div className="bg-gray-700 rounded text-[12px] text-white px-[8px] h-[16px] flex items-center">
						<strong>{ params.value?.length }</strong>
					</div>
				)}
			</div>
		</div>
	);
};

export default KeywordsCellRenderer;
